/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_StartInputs */

const en_course_start = /** @type {(inputs: Course_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start course`)
};

const ja_course_start = /** @type {(inputs: Course_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コースを開始`)
};

const fr_course_start = /** @type {(inputs: Course_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer le cours`)
};

const de_course_start = /** @type {(inputs: Course_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurs starten`)
};

/**
* | output |
* | --- |
* | "Start course" |
*
* @param {Course_StartInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const course_start = /** @type {((inputs?: Course_StartInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_StartInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_course_start(inputs)
	if (locale === "ja") return ja_course_start(inputs)
	if (locale === "fr") return fr_course_start(inputs)
	return de_course_start(inputs)
});